import React, { useEffect, useState } from "react";
import TooltipBox from "./TooltipBox";
import ScrollableChipComponent from "./ScrollableChipComponent";

const CardContainer = ({
  isOpen,
  setIsOpen,
  filtersData,
  deleteFilterOption,
  resetAll,
  banner,
  handleReset,
  values,
  fetchAllTemplates,
  getFilterDataToDisplay,
  getSearchedTemplates,
  setValues,
  setSearchText,
  setnobannerFound,
  searchText,
  noData,
  setGenericInfo,
  genericInfo,
  isSearchBarEmpty,
  setIsSearchBarEmpty,
  // New props for sync
  selectedFilters,
  setSelectedFilters,
  handleResetSync,
}) => {
  const [hasNonEmptyValue, setHasNonEmptyVale] = useState(false);

  useEffect(() => {
    const hasNonEmptyValue =
      (values["brand"] &&
        Array.isArray(values["brand"]) &&
        values["brand"].length > 0) ||
      (values["market"] &&
        Array.isArray(values["market"]) &&
        values["market"].length > 0) ||
      (values["templateType"] &&
        Array.isArray(values["templateType"]) &&
        values["templateType"].length > 0) ||
      (values["contentType"] &&
        Array.isArray(values["contentType"]) &&
        values["contentType"].length > 0) ||
      (values["mlrStatus"] &&
        Array.isArray(values["mlrStatus"]) &&
        values["mlrStatus"].length > 0) ||
      (values["indication"] &&
        Array.isArray(values["indication"]) &&
        values["indication"].length > 0) ||
      (values?.templateNameInput && values.templateNameInput.trim() !== "");
    setHasNonEmptyVale(hasNonEmptyValue);
  });

  return (
    <div>
      {hasNonEmptyValue && (
        <div className="col-12 plr20">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <ScrollableChipComponent
              filterDataToDisplay={getFilterDataToDisplay()}
              deleteFilterOption={deleteFilterOption}
              fetchAllTemplates={fetchAllTemplates}
              resetAll={resetAll}
              handleReset={handleReset}
              getSearchedTemplates={getSearchedTemplates}
              setValues={setValues}
              values={values}
              setSearchText={setSearchText}
              searchText={searchText}
              setnobannerFound={setnobannerFound}
              noData={noData}
              setGenericInfo={setGenericInfo}
              genericInfo={genericInfo}
              setIsSearchBarEmpty={setIsSearchBarEmpty}
              isSearchBarEmpty={isSearchBarEmpty}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              handleResetSync={handleResetSync}
            />
          </div>
        </div>
      )}
      {!hasNonEmptyValue && <div style={{ marginBottom: "10px" }}></div>}
      <div className="cards-container">
        {banner && (
          <TooltipBox banner={banner} setIsOpen={setIsOpen} isOpen={isOpen} />
        )}
      </div>
    </div>
  );
};

export default CardContainer;
